import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const BLINKING_INTERVAL = 1500;

export class MessageIndicatorComponent extends Component {
    static propTypes = {
        unreadCount: PropTypes.number.isRequired,
        messageIndicatorTitleSingular: PropTypes.string.isRequired,
        messageIndicatorTitlePlural: PropTypes.string.isRequired,
    };

    state = {
        initialDocumentTitle: global.document ? document.title : '',
        currentTitle: global.document ? document.title : '',
        lastSetTitle: '',
    };

    blinkTitle() {
        if (!this.blinkInterval) {
            const fn = () => {
                const { messageIndicatorTitleSingular, messageIndicatorTitlePlural, unreadCount } = this.props;
                const { currentTitle, lastSetTitle } = this.state;
                let { initialDocumentTitle } = this.state;

                const title = document.title;

                if (title !== initialDocumentTitle && title !== lastSetTitle) {
                    // document title changed for something we don't control, this is the new initial title
                    this.setState({
                        initialDocumentTitle: title,
                    });

                    initialDocumentTitle = title;
                }

                if (currentTitle === initialDocumentTitle && unreadCount > 0) {
                    const newTitle = unreadCount === 1 ? messageIndicatorTitleSingular : messageIndicatorTitlePlural;

                    this.setState({
                        currentTitle: newTitle.replace('{count}', unreadCount),
                        lastSetTitle: newTitle.replace('{count}', unreadCount),
                    });
                } else {
                    this.setState({
                        currentTitle: initialDocumentTitle,
                    });
                }
            };
            this.blinkInterval = setInterval(fn, BLINKING_INTERVAL);
        }
    }

    cancelBlinking() {
        const { currentTitle, initialDocumentTitle } = this.state;
        if (this.blinkInterval) {
            clearInterval(this.blinkInterval);
            delete this.blinkInterval;
        }

        if (currentTitle !== initialDocumentTitle) {
            this.setState({
                currentTitle: initialDocumentTitle,
            });
        }
    }

    UNSAFE_componentWillReceiveProps({ unreadCount }) {
        if (unreadCount > 0) {
            this.blinkTitle();
        } else {
            this.cancelBlinking();
        }
    }

    componentDidMount() {
        const { unreadCount } = this.props;
        if (unreadCount > 0) {
            this.blinkTitle();
        }
    }

    componentWillUnmount() {
        this.cancelBlinking();

        // do it manually because `DocumentTitle` will be unmounted
        document.title = this.state.initialDocumentTitle;
    }

    render() {
        if (global.document) {
            document.title = this.state.currentTitle;
        }
        return null;
    }
}

export default connect(({ ui: { text }, conversations, appState: { activeConversationId } }) => {
    const { unreadCount } = conversations[activeConversationId];
    return {
        unreadCount,
        messageIndicatorTitleSingular: text.messageIndicatorTitleSingular,
        messageIndicatorTitlePlural: text.messageIndicatorTitlePlural,
    };
})(MessageIndicatorComponent);
